export const filesList = (state) => state.file.list;
export const fileDetails = (state) => state.file.details;
export const filesIsFetching = (state) => state.file.isFetching;
export const projectFiles = (state) => state.file.projectFiles;
export const fileSearchList = (state) => state.file.searchResult;
export const fileSearchEnabled = (state) => state.file.searchEnabled;
export const fileSearchIsFetching = (state) => state.file.isSearchFetching;
export const timestamp = (state) => state.file.timestamp;
export const getFilter = (state) => state.file.filter;
export const isFetched = (state) => state.file.isFetched;
